/* SAEGE - collection "load more" / infinite scroll.
   Progressive enhancement over the theme's normal ?page=N pagination:
   - the numbered links stay in the HTML (for Google and no-JS) but are hidden once this runs
   - the next page loads automatically when the shopper nears the end of the grid,
     with a "Load more" button as a fallback (and after an error)
   - products are appended into the existing .product-list, so the theme's delegated
     handlers (hover image, image arrows, swatches) and the "+" quick add keep working
   - Shop the look / review tiles from later pages are skipped so they don't repeat
   - survives the theme's AJAX filter + sort (the pagination row is re-rendered; we re-bind)
   - back from a product page: re-loads the same number of pages and restores scroll
   UI markup lives in snippets/saege-load-more.liquid (rendered in the pagination row). */
(function () {
  if (window.SaegeLoadMore) return;
  window.SaegeLoadMore = true;

  var STORE_KEY = 'saege-load-more';
  var AUTO_MARGIN = '0px 0px 1200px 0px'; // start loading ~1.5 screens before the end
  var state = null;
  var io = null;

  function listEl() { return document.querySelector('.collection-listing .product-list'); }
  function uiEl() { return document.querySelector('[data-saege-lm]'); }

  function count() {
    var l = listEl();
    return l ? l.querySelectorAll('.product-block[data-product-id]').length : 0;
  }

  function render() {
    var ui = uiEl();
    if (!ui || !state) return;
    var shown = count();
    var status = ui.querySelector('[data-saege-lm-status]');
    if (status) status.textContent = 'Showing ' + Math.min(shown, state.total) + ' of ' + state.total;
    var bar = ui.querySelector('[data-saege-lm-bar]');
    if (bar) bar.style.width = Math.min(100, Math.round((shown / state.total) * 100)) + '%';
    var btn = ui.querySelector('[data-saege-lm-button]');
    if (btn) {
      btn.hidden = !state.next;
      btn.disabled = state.loading;
      btn.textContent = state.loading ? 'Loading…' : 'Load more';
    }
    ui.classList.toggle('is-done', !state.next);
  }

  function load() {
    if (!state || state.loading || !state.next) return Promise.resolve();
    state.loading = true;
    render();
    var url = state.next;
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var incoming = doc.querySelector('.collection-listing .product-list');
        var list = listEl();
        if (!incoming || !list) throw new Error('no grid');
        var seen = {};
        list.querySelectorAll('.product-block[data-product-id]').forEach(function (el) { seen[el.getAttribute('data-product-id')] = 1; });
        var frag = document.createDocumentFragment();
        Array.prototype.forEach.call(incoming.children, function (el) {
          if (!el.matches('.product-block[data-product-id]')) return;         // skip scripts, review + Shop the look tiles
          if (el.matches('.saege-stl, .product-block-review')) return;
          if (seen[el.getAttribute('data-product-id')]) return;               // never show a product twice
          el.removeAttribute('data-cc-animate');                              // no fade-in stagger on appended rows
          frag.appendChild(document.importNode(el, true));
        });
        list.appendChild(frag);
        if (window.theme) {
          try { theme.loadLazyBGSet && theme.loadLazyBGSet(list); } catch (e) {}
        }
        var nextLink = doc.querySelector('.pagination-row .pagination__next');
        state.next = nextLink ? nextLink.getAttribute('href') : null;
        state.page += 1;
        state.loading = false;
        state.failed = false;
        render();
        document.dispatchEvent(new CustomEvent('saege:load-more', { detail: { page: state.page } }));
      })
      .catch(function (err) {
        if (window.console) console.warn('[saege-load-more]', err);
        state.loading = false;
        state.failed = true;              // stop auto-loading, leave the button
        if (io) io.disconnect();
        render();
      });
  }

  function init() {
    var ui = uiEl();
    if (io) { io.disconnect(); io = null; }
    if (!ui || !listEl()) { state = null; return; }
    if (ui.getAttribute('data-saege-lm-ready')) return;
    ui.setAttribute('data-saege-lm-ready', '1');
    document.documentElement.classList.add('saege-lm-on'); // hides the numbered pagination

    state = {
      total: parseInt(ui.getAttribute('data-total'), 10) || count(),
      page: parseInt(ui.getAttribute('data-page'), 10) || 1,
      next: ui.getAttribute('data-next') || null,
      loading: false,
      failed: false
    };
    render();

    ui.querySelector('[data-saege-lm-button]').addEventListener('click', function () { load(); });

    var sentinel = ui.querySelector('[data-saege-lm-sentinel]');
    if ('IntersectionObserver' in window && sentinel) {
      io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting && state && !state.failed) {
          load().then(function () {
            // if the new rows still don't fill the screen, keep going
            if (state && state.next && !state.failed && sentinel.getBoundingClientRect().top < window.innerHeight + 1200) load();
          });
        }
      }, { rootMargin: AUTO_MARGIN });
      io.observe(sentinel);
    }
  }

  /* ---- back button: put the shopper back where they were ---- */
  function pageKey() { return location.pathname + location.search; }

  function remember() {
    if (!state || state.page <= 1) return;
    try {
      sessionStorage.setItem(STORE_KEY, JSON.stringify({ key: pageKey(), page: state.page, y: window.scrollY, t: Date.now() }));
    } catch (e) {}
  }

  function restore() {
    var saved = null;
    try { saved = JSON.parse(sessionStorage.getItem(STORE_KEY) || 'null'); sessionStorage.removeItem(STORE_KEY); } catch (e) {}
    if (!saved || saved.key !== pageKey() || Date.now() - saved.t > 30 * 60 * 1000) return;
    var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    if (nav && nav.type !== 'back_forward') return;
    if (!state || saved.page <= state.page) return;
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    (function step() {
      if (state && state.page < saved.page && state.next && !state.failed) return load().then(step);
      window.scrollTo(0, saved.y);
    })();
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.collection-listing a[href*="/products/"]');
    if (a) remember();
  }, true);
  window.addEventListener('pagehide', remember);

  /* ---- theme AJAX filter / sort re-renders the pagination row: re-bind ---- */
  function watch() {
    var mo = new MutationObserver(function () {
      var ui = uiEl();
      if (ui && !ui.getAttribute('data-saege-lm-ready')) init();
      else if (!ui && state) { state = null; if (io) io.disconnect(); document.documentElement.classList.remove('saege-lm-on'); }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  function start() { init(); restore(); watch(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
